import React from 'react';
import { useIntl } from 'react-intl';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare } from '@fortawesome/pro-light-svg-icons/faArrowUpRightFromSquare';
import { TypedMemo } from '../../../common/types';
import { API_DOCS_URL } from './apiDocsUrl';

/** The link to the hosted API reference. The Quickstart head and the locked tab show it. */
const ApiDocsButtonComponent: React.FC<{ size?: 'sm' }> = ({ size }) => {
  const intl = useIntl();
  return (
    <Button color="light" size={size} href={API_DOCS_URL} target="_blank" rel="noopener noreferrer" tag="a">
      <FontAwesomeIcon icon={faArrowUpRightFromSquare} className="me-2" />
      {intl.formatMessage({
        id: 'app.sml.settings.api.docs.link',
        defaultMessage: 'API documentation',
      })}
    </Button>
  );
};

export const ApiDocsButton = TypedMemo(ApiDocsButtonComponent);
